<!-- ワンタッチパスコンポーネント (登録) -->
<template>
    <form @submit.prevent="submit">
        <dl class="formContainer">
            <dt>登録クラブ<em>必須</em></dt>
            <dd>
            <span class="select full">
                <select v-model="oneTouchPassClubCode">
                    <option value="" selected>選択してください</option>
                    <template v-for="league in leagues">
                        <optgroup :label="'---------------- ' + league + ' ----------------'"></optgroup>
                        <option v-for="club in getSpecifiedClubTeams(league)"
                                :value="club.clubCode">{{ club.teamName }}</option>
                    </template>
                </select>
            </span>
            </dd>
        </dl>

        <div class="btnSpace duo">
            <button @click="back"
                    type="button"
                    name="back"
                    class="return">戻る</button>
            <button type="submit"
                    :disabled="isDisabled">次へ</button>
        </div>
    </form>
</template>

<script>
import { mixinJleague } from '../../mixin/utility'

export default {
    name: 'RegistOneTouchForm',
    mixins: [mixinJleague],
    data: function(){
        return {
            leagues: ['J1', 'J2', 'J3'],
            oneTouchPassClubCode: ''
        }
    },
    props: {
        isVisible: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        isDisabled: function(){
            return this.oneTouchPassClubCode === '';
        }
    },
    methods: {
        submit: function(){
            let backUrl = location.href;
            if (typeof jleagueClient !== 'undefined') {
                if (typeof jleagueClient.redirect_url !== 'undefined' && jleagueClient.redirect_url !== '') {
                    backUrl = jleagueClient.redirect_url;
                }
            }
            const query = getParameter(backUrl);
            query['sid'] = '3005';
            if (typeof jleagueClient !== 'undefined') {
                if (typeof jleagueClient.redirect_url !== 'undefined' && jleagueClient.redirect_url !== '') {
                    query['jlogin'] = '1';
                }
                if (typeof jleagueClient.client_id !== 'undefined' && jleagueClient.client_id !== '') {
                    query["client_id"] = jleagueClient.client_id;
                }
            }
            backUrl = setParameter(query, backUrl);
            const redirectUrl = 'https://stg2-my.jleague.jp/my/'
                + this.oneTouchPassClubCode
                + '/card/regist?jlogin=1&backUrl='
                + backUrl;

            location.href = redirectUrl;
        },
        back: function(){
            this.$emit('toggle-element', !this.isVisible);
        }
    }
}
</script>
